import { ghostBtnClass, mfgPrimaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

/** Sticky bar for multiselect confirm of pending named-variant applications. */
export function ManufacturingNamedVariantApplicationsBulkBar({
  selectedCount,
  pendingFilteredCount,
  allPendingFilteredSelected,
  saveBusy,
  onSelectAllPendingFiltered,
  onClear,
  onConfirmSelected,
}: {
  selectedCount: number;
  pendingFilteredCount: number;
  allPendingFilteredSelected: boolean;
  saveBusy: boolean;
  onSelectAllPendingFiltered: () => void;
  onClear: () => void;
  onConfirmSelected: () => void;
}) {
  if (selectedCount === 0 && pendingFilteredCount === 0) return null;

  if (selectedCount === 0) {
    return (
      <div className="rounded-xl border border-gray-200 bg-white/90 px-3 py-2 dark:border-zinc-700 dark:bg-zinc-900/80">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs text-gray-600 dark:text-zinc-400">
            {pendingFilteredCount} pending application
            {pendingFilteredCount === 1 ? "" : "s"}
          </span>
          <button
            type="button"
            className={ghostBtnClass}
            disabled={saveBusy}
            onClick={onSelectAllPendingFiltered}
          >
            Select all pending ({pendingFilteredCount})
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="sticky top-0 z-10 rounded-xl border border-indigo-200 bg-indigo-50/80 px-3 py-2 shadow-sm backdrop-blur dark:border-indigo-800 dark:bg-indigo-950/60">
      <div className="flex flex-wrap items-center gap-2">
        <div className="text-sm font-medium text-indigo-900 dark:text-indigo-100">
          {selectedCount} selected
        </div>
        <button
          type="button"
          className={mfgPrimaryBtnClass}
          disabled={saveBusy}
          onClick={onConfirmSelected}
        >
          Confirm selected ({selectedCount})
        </button>
        {!allPendingFilteredSelected && pendingFilteredCount > 0 ? (
          <button
            type="button"
            className={ghostBtnClass}
            disabled={saveBusy}
            onClick={onSelectAllPendingFiltered}
          >
            Select all pending ({pendingFilteredCount})
          </button>
        ) : null}
        <button type="button" className={ghostBtnClass} disabled={saveBusy} onClick={onClear}>
          Clear selection
        </button>
      </div>
    </div>
  );
}
